import { lazyImport } from '@/utils/lazyImport';

const { AuthRoutes } = lazyImport(() => import('@/features/auth'), 'AuthRoutes');
const { NotAuthRoutes } = lazyImport(() => import('@/features/auth'), 'NotAuthRoutes');

export const publicRoutes = [
  {
    path: '/auth/*',
    element: <AuthRoutes />,
  },
  {
    path: '/*',
    element: <NotAuthRoutes />,
  },
];
